import { useState, useEffect } from "react";

const WHATSAPP_NUMBER = "393482204153"; // international format without '+'
const PREFILL = "Salve, vi contatto dal vostro sito web per chiedere informazioni.";

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Soft entrance animation after page load
    const t = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILL)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      data-testid="whatsapp-fab"
      className={`fixed bottom-5 right-5 lg:bottom-7 lg:right-7 z-40 group inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-3 pr-5 lg:pr-6 py-3 rounded-full shadow-lg shadow-emerald-900/20 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center shrink-0">
        {/* WhatsApp glyph */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 1.04-2.054 1.93-2.879 2.054-.825.124-1.815.176-2.927-.183-.674-.214-1.54-.5-2.65-.98-4.661-2.01-7.706-6.703-7.938-7.012-.232-.31-1.892-2.514-1.892-4.792 0-2.279 1.197-3.4 1.622-3.864.426-.464.928-.58 1.236-.58.31 0 .619.003.89.016.285.014.667-.108 1.043.797.387.929 1.312 3.207 1.427 3.439.116.232.193.503.039.812-.155.31-.232.503-.464.773-.232.27-.488.604-.696.811-.232.232-.473.483-.203.946.27.464 1.199 1.978 2.572 3.205 1.766 1.577 3.255 2.066 3.719 2.298.464.232.733.193 1.004-.116.27-.31 1.16-1.353 1.469-1.816.31-.464.619-.387 1.044-.232.426.155 2.704 1.276 3.168 1.508.464.232.773.348.889.541.116.193.116 1.122-.255 2.207zM12 0C5.373 0 0 5.373 0 12c0 2.116.553 4.106 1.523 5.832L.04 24l6.31-1.651A11.929 11.929 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
        </svg>
      </span>
      <span className="text-sm font-medium tracking-wide hidden sm:inline">
        Scrivici su WhatsApp
      </span>
      <span className="text-sm font-medium tracking-wide sm:hidden">WhatsApp</span>
    </a>
  );
}
